module.exports = __webpack_public_path__ + "img/l.6dfb2133.jpg";